import { BehaviorSubject } from 'rxjs';
import { UserProfile } from 'src/app/core/models/user';
import { Router, ActivatedRoute } from '@angular/router';
import { GDPRService } from 'src/app/core/services/rulebook';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { RuleTypeName, RulebookModel } from 'src/app/core/models/rulebook';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { AnalyticsService } from './../../core/services/analytics/analytics.service';
import { LibraryFilterModel } from './../../core/models/regulation/library-filter.model';
import { Location } from '@angular/common';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss'],
})
export class LibraryComponent implements OnInit {

  @ViewChild('libraryTabs') libraryTabs: any;
  isLoadingMain = false;
  libraryMenu: Array<MenuItemModel>;

  ruleBook: RulebookModel;
  rulebookTypeName = '';
  libraryRuleTypeName = RuleTypeName.GDPR;

  regulationFilter: LibraryFilterModel;
  linkedUpdatesFilter: BehaviorSubject<LibraryFilterModel>;
  ruleBooksFilter: BehaviorSubject<LibraryFilterModel>;
  isTabMenuItem = false;
  isReportingTemplate = false;

  //For Report Template
  reportTemplateUrl: string;

  constructor(
    private router: Router, private location: Location,
    public sessionService: SessionService,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    public gdprService: GDPRService,
    public authService: AuthService,
    private cdr: ChangeDetectorRef) {

    this.regulationFilter = new LibraryFilterModel();
    this.linkedUpdatesFilter = new BehaviorSubject<LibraryFilterModel>(new LibraryFilterModel());
    this.ruleBooksFilter = new BehaviorSubject<LibraryFilterModel>(new LibraryFilterModel());

    this.ruleBook = new RulebookModel();
    this.libraryMenu = [];
    this.sessionService.isLibraryTabActive = this.router.url.indexOf('/library/rule-detail/') >= 0 ? true : false;
    const rulebookName = this.route.snapshot.params.rulebook;
    this.rulebookTypeName = rulebookName;
    this.reportTemplateUrl = this.location.path();
    if (this.reportTemplateUrl.includes('reporting-templates')) {
      this.isReportingTemplate = true;
    }
  }

  ngOnInit(): void {
    this.getUserMenu();
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  getUserMenu(): void {
    this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
      this.libraryMenu = data;
    });
  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(a => a.screenUrl === currentUrl && a.parentId != null) ? true : false;
    
  }

  getTabText(url: string): void {
    this.sessionService.isLibraryTabActive = url === 'Details' ? true : false;
    this.cdr.detectChanges();
  }
}
